import moment from 'moment'
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

export const useWorkTimeOverlap = () => {
  const showModal = ref(false)
  const newWorkTimeEntry = ref(null)
  const warningOverlappedMechanic = ref(null)
  const warningOverlappedWorkTimeEntries = ref([])
  const warningOverlappedWorksheets = ref([])

  const cleanedWarnings = (items, intFields = []) => {
    if (!Array.isArray(items)) return []

    return items.map(item => {
      const cleaned = {}

      for (const [key, value] of Object.entries(item)) {
        let newValue = value

        if (newValue === 'None') newValue = null

        if (intFields.includes(key) && newValue != null) {
          const parsed = parseInt(newValue, 10)
          newValue = isNaN(parsed) ? newValue : parsed
        }

        cleaned[key] = newValue
      }

      return cleaned
    })
  }

  const buildErrorMessage = (errorDetails) => {
    const detail = errorDetails?.details?.find(d =>
      d.errors?.find(e => e.code === 'error.validation.work_time_entry_overlap')
    )

    const error = detail?.errors?.find(e => e.code === 'error.validation.work_time_entry_overlap')

    if (!error) return false

    newWorkTimeEntry.value = {
      start: error.params?.newWorkTimeEntry.start,
      end: error.params?.newWorkTimeEntry?.end !== 'None'
        ? error.params?.newWorkTimeEntry?.end
        : null
    }

    warningOverlappedMechanic.value = error.params?.mechanic
    warningOverlappedWorkTimeEntries.value = cleanedWarnings(error.params?.workTimeEntries, ['id', 'worksheet_id'])
    warningOverlappedWorksheets.value = cleanedWarnings(error.params?.worksheets, ['id', 'customer_id', 'deposit', 'garage', 'garage_reason_ref', 'payment_type_ref', 'supplier_brand_ref'])

    return true
  }

  return {
    showModal,
    newWorkTimeEntry,
    warningOverlappedMechanic,
    warningOverlappedWorkTimeEntries,
    warningOverlappedWorksheets,
    buildErrorMessage
  }
}

export const endEditorPreparing = (e, editors) => {
  if (e.parentType === 'dataRow' && e.dataField === 'end') {
    e.editorOptions.onInitialized = (e) => { editors['end'] = e.component }
    const start = e.row?.data?.start

    if (start) {
      const startDate = new Date(start)
      const isSameDay = (d) => moment(d.date).isSame(startDate, 'day')
      e.editorOptions.min = startDate
      e.editorOptions.disabledDates = (d) => !isSameDay(d)
    }
  }
}

export const createStopButton = ({ onStopClick, isVisible }) => {
  const i18n = getI18n()

  return {
    name: 'stop',
    text: i18n.t('common.stop'),
    icon: 'mdi-stop-circle-outline',
    class: ['dx-link', 'dx-icon', 'mdi', 'mdi-stop-circle-outline', 'dx-link-icon', 'icon-red'],
    onClick: (e) => onStopClick({ id: e.entityId }),
    visibleFn: isVisible
  }
}
